import { uiloosTypewriter, uiloosLicenseChecker } from 'public/uiloos.min.js';

uiloosLicenseChecker.licenseChecker.activateLicense('wix-oem', {
  logLicenseActivated: false,
});

class UiloosTypewriter extends HTMLElement {
  connectedCallback() {
    this.play();
  }

  play() {
    
    if (!this.config) {
      return;
    }

    this.innerHTML = '';
    
    const typewriterEl = document.createElement('div');

    this.append(typewriterEl);

     const config = JSON.parse(this.config);

    if (!config.useCustomCSS) {
      typewriterEl.className = 'uiloos-typewriter';

      const styleEl = document.createElement('style');
      const styleContent = getStyle(config);
      styleEl.innerHTML = styleContent;
      this.append(styleEl);
    } else {
      typewriterEl.className = 'wixui-uiloos-typewriter';
    }

    this.typewriter = uiloosTypewriter.typewriterFromSentences(
      config,
      (typewriter) => {
        typewriterEl.innerHTML = typewriter.text;

        const cursorEl = document.createElement('span');

        if (!config.useCustomCSS) {
          cursorEl.className = 'uiloos-typewriter-cursor';
        } else {
          cursorEl.className = 'wixui-uiloos-typewriter-cursor';
        }

        if (typewriter.cursors[0].isBlinking) {
          cursorEl.classList.add('blinking');
        }
        typewriterEl.append(cursorEl);
      }
    );

    if (config.pauseOnHover) {
      typewriterEl.onmouseenter = () => {
        this.typewriter.pause();
      };

      typewriterEl.onmouseleave = () => {
        this.typewriter.play();
      };
    }
  }

  static get observedAttributes() {
    return ['config'];
  }

  get config() {
    return this.getAttribute('config');
  }

  set config(value) {
    return this.setAttribute('config', value);
  }

  attributeChangedCallback() {
    this.play();
  }

  disconnectedCallback() {
    this.innerHTML = '';
    this.typewriter = null;
  }
}

customElements.define('uiloos-typewriter', UiloosTypewriter);

function getStyle(config) {
  return `
    .uiloos-typewriter {
      font-family: "${config.font}", monospace;
      color: ${config.fontColor};
      font-size: ${config.fontSize};
      display: inline-block;
      text-align: ${config.textAlign};
      ${config.textAlign !== 'left' ? 'width: 100%;' : ''}
    }

    .uiloos-typewriter-cursor {
      border-right-width: ${config.cursorWidth};
      border-right-style: solid;
      border-color: ${config.cursorColor};
    }

    .uiloos-typewriter-cursor.blinking { 
      animation: uiloos-typewriter-blink 0.75s step-start infinite;
    }

    @keyframes uiloos-typewriter-blink {
      from,
      to {
        border-color: transparent;
      }
      50% {
        border-color: ${config.cursorColor};
      }
    }
  `;
}